module.exports = __webpack_public_path__ + "img/6.40c77321.png";